// extracted by mini-css-extract-plugin
module.exports = {"destinationRow":"NavRail_destinationRow__ckLC9"};